//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import {
  ContentLibraryContentGroup,
  ContentLibrarySourcesGroups,
  IContentLibraryItemParams,
  RIGHTS_STATUS,
} from '@apis/content-library/contentLibraryApiModel';

import { RoutableStateName } from 'app/top-level-states';

export const GRID_CONTENT_DISTRIBUTION_CARD_HEIGHT = 364;

/**
 * Pages where the bulk reject action should be available.
 */
export const AI_MODERATION_BULK_REJECT_PAGES: ReadonlySet<RoutableStateName> =
  new Set<RoutableStateName>(['library.distribute', 'library.needs-action']);

// TODO: PD-310678 - pass correct filters for each page
export const readyToDistributeInitialFilterParams: IContentLibraryItemParams = {
  filters: {
    hasProducts: true,
    rightsStatuses: [RIGHTS_STATUS.OWNED, RIGHTS_STATUS.APPROVED],
  },
  sources: {
    sourcesGroups: [ContentLibrarySourcesGroups.ALL_MEDIA],
    contentGroup: ContentLibraryContentGroup.NOTHING,
  },
};

// TODO: PD-310678 - pass correct filters for each page
export const needsActionInitialFilterParams: IContentLibraryItemParams = {
  filters: {
    rightsStatuses: [
      RIGHTS_STATUS.QUEUED,
      RIGHTS_STATUS.PENDING,
      RIGHTS_STATUS.NOT_SET,
      RIGHTS_STATUS.FAILED_TO_SEND,
    ],
  },
  sources: {
    sourcesGroups: [ContentLibrarySourcesGroups.ALL_MEDIA],
    contentGroup: ContentLibraryContentGroup.NOTHING,
  },
};

// TODO: PD-310678 - pass correct filters for each page
export const rejectedInitialFilterParams: IContentLibraryItemParams = {
  filters: {
    rightsStatuses: [RIGHTS_STATUS.EXPIRED],
  },
  sources: {
    sourcesGroups: [ContentLibrarySourcesGroups.ALL_MEDIA],
    contentGroup: ContentLibraryContentGroup.NOTHING,
  },
};
